// Thin wrapper around window.location.reload() so call sites can be
// unit-tested: jsdom marks window.location (and its methods) non-configurable
// under jest 30, making the global impossible to mock directly.
export const hardReload = () => window.location.reload();
